import { HttpClient } from '@wix/sdk-types';
import {
  GetCheckoutContentIdentifiers,
  GetCheckoutContentOptions,
  GetCheckoutContentResponse,
  getCheckoutContent as universalGetCheckoutContent,
} from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getCheckoutContent(
  httpClient: HttpClient
): GetCheckoutContentSignature {
  return (
    identifiers: GetCheckoutContentIdentifiers,
    options?: GetCheckoutContentOptions
  ) =>
    universalGetCheckoutContent(
      identifiers,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetCheckoutContentSignature {
  /**
   * Retrieves a CheckoutContent.
   */
  (
    identifiers: GetCheckoutContentIdentifiers,
    options?: GetCheckoutContentOptions | undefined
  ): Promise<GetCheckoutContentResponse>;
}

export {
  CheckoutContent,
  CheckoutContentProvider,
  GetCheckoutContentIdentifiers,
  GetCheckoutContentOptions,
  GetCheckoutContentRequest,
  GetCheckoutContentResponse,
} from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';
